import slugify from "slugify";
import { EntretienCreation } from "../creation/data";

// hero
import ramassage_de_feuille_hero from "../../../assets/images/conceptions-entretien/ramassage_de_feuille.jpg";
import taille_hero from "../../../assets/images/conceptions-entretien/taille.jpg";
import tonte_hero from "../../../assets/images/conceptions-entretien/tonte.jpg";
import mineralisation_hero from "../../../assets/images/conceptions-entretien/mineralisation.jpg";
import enretien_des_massif_hero from "../../../assets/images/conceptions-entretien/enretien-des-massifs.jpg";
import entretien_des_pelouses_hero from "../../../assets/images/conceptions-entretien/entretien_des_pelouses.jpg";
import brossage_mecanique_hero from "../../../assets/images/conceptions-entretien/brossage_mecanique.jpg";

// card
import ramassage_de_feuille_card from "../../../assets/images/conceptions-entretien/card-images/ramassage_de_feuille.jpg";
import taille_card from "../../../assets/images/conceptions-entretien/card-images/taille.jpg";
import tonte_card from "../../../assets/images/conceptions-entretien/card-images/tonte.jpg";
import mineralisation_card from "../../../assets/images/conceptions-entretien/card-images/mineralisation.jpg";
import enretien_des_massif_card from "../../../assets/images/conceptions-entretien/card-images/enretien_des_massif.jpg";
import entretien_des_pelouses_card from "../../../assets/images/conceptions-entretien/card-images/entretien_des_pelouses.jpg";
import brossage_mecanique_card from "../../../assets/images/conceptions-entretien/card-images/brossage_mecanique.jpg";

// logo plan
import ramassage_de_feuille_plan from "../../../assets/images/conceptions-entretien/ramassages-des-feuilles-mortes.svg";
import taille_plan from "../../../assets/images/conceptions-entretien/taille.svg";
import tonte_plan from "../../../assets/images/conceptions-entretien/tonte.svg";
import mineralisation_plan from "../../../assets/images/conceptions-entretien/mineralistion.svg";
import enretien_des_massif_plan from "../../../assets/images/conceptions-entretien/entretien-des-massifs.svg";
import entretien_des_pelouses_plan from "../../../assets/images/conceptions-entretien/entretien-des-surfaces-engazonnees.svg";
import brossage_mecanique_plan from "../../../assets/images/conceptions-entretien/brossage.svg";

export const steps = [
  {
    title: "Prestation de jardinage",
    text: "<p>Mise à disposition d&apos;un jardinier paysagiste pour une durée déterminée au préalable.</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
  {
    title: "Prestation devisé",
    text: "<p>Intervention ponctuelle suite à un devis.</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
  {
    title: "Prestation intégrale",
    text: "<p>Mise en place d&apos;une solution clé en main avec un contrat d&apos; entretien défini à l&apos;année.</p>",
    image: "https://dummyimage.com/520x301/878787/ffffff.jpg",
  },
];

const mainDetailsImageDir = "/images/savoir-faire/entretien";

export const entretienData: EntretienCreation[] = [
  {
    title: "Ramassage de feuilles",
    textsCard: [
      "Les températures baissent et les arbres se préparent pour l&apos; hiver. Afin de se préserver du froid, les feuilles fanent et tombent... Confiez-nous leur ramassage.",
    ],
    textDetail: /* html */ `<p>Manuel ou mécanisé, <span>nous nous adaptons à votre terrain</span></p>`,
    image: ramassage_de_feuille_card,
    heroImage: ramassage_de_feuille_hero,
    dirDetailsImage: "ramassage-feuilles",
    logoPlan: ramassage_de_feuille_plan,
    details: {
      items: [
        {
          title: "Savoir-faire 1",
          text: `
          <p>Les feuilles tombées au sol risquent d&apos;étouffer votre gazon et d&apos;y créer des trous. Elles rendent aussi les surfaces glissantes et peuvent donc provoquer des chutes dangereuses.
          Nous vous proposons de les ramasser pour vous. 
          </p>
          <p>Bon à savoir : Mises au pied des haies ou dans les massifs, elles  créées un excellent paillage naturel qui amendera vos végétaux, gardera l&apos; humidité plus longtemps et limitera en partie la pousse des adventices. </p>`,
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Taille",
    textsCard: [
      "Qu&apos;elle soit en tire-sève, de formation, d&apos;éclaircie, sanitaire... nous pouvons vous accompagner pour le soin des vos plantes.",
    ],
    textDetail: /* html */ `<p>En fonction du type de taille nécessaire, cette opération permet de <span>façonner</span> le végétal, de le <span>nettoyer</span> et de le <span>soigner</span>.</p>`,
    image: taille_card,
    heroImage: taille_hero,
    dirDetailsImage: "taille",
    logoPlan: taille_plan,
    details: {
      items: [
        {
          title: "De formation",
          text: "<p>“Première” taille du jeune sujet, elle permet de mettre toutes les chances de son côté pour avoir un développement harmonieux et équilibré de la plante. </p>",
        },
        {
          title: "De reformation ou Rabattage",
          text: "<p>En général réservée aux végétaux qui ont un certain âge ou un âge certain et qui ont été délaissés trop longtemps. Elle a pour but de redonner une forme plus en adéquation avec son environnement. </p>",
        },
        {
          title: "En tire-sève ",
          text: "<p>Elle permet d&apos; améliorer le flux nutritionnel de la plante vers les zones où l&apos;on souhaite orienter la croissance.</p>",
        },
        {
          title: "Sanitaire",
          text: "<p>Elle permet d&apos;éliminer les bois morts ou malades de vos végétaux et ainsi éviter son déclin prématuré.</p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Tonte",
    textsCard: [
      "Le secret d&apos;une bonne tonte ? Il faut qu&apos;elle soit ni trop haute ni trop basse et qu&apos;elle soit faite le plus souvent possible. ",
    ],
    image: tonte_card,

    textDetail: /* html */ `<p>Etape essentielle pour avoir une surface engazonnée <span>résiliente</span> et <span>régulière</span> il existe globalement deux façons de la tondre.</p>`,
    heroImage: tonte_hero,
    dirDetailsImage: "tonte",
    logoPlan: tonte_plan,
    details: {
      items: [
        {
          title: "Avec ramassage",
          text: `<p>L&apos; avantage de cette solution est qu&apos; elle permet la non propagation de certaines maladies et un moindre développement du feutre. Les tontes peuvent être plus espacées mais chaque passage appauvri le sol. 
          Pensez à nourrir votre sol à l&apos;aide d&apos;engrais adapté. </p>`,
        },
        {
          title: "En mulching",
          text: `<p>Le principe de cette tonte est de laisser ce qui est coupé sur place. En se décomposant, les résidus de coupe nourrissent naturellement le sol et renforcent ainsi votre gazon. Un passage régulier permet d'optimiser ses bienfaits.</p>`,
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Minéralisation ",
    textsCard: [
      "Nous pouvons vous proposer la minéralisation de certaines de vos surfaces afin de les protéger durablement",
    ],
    textDetail: /* html */ `<p>Solution non filmogène pour la <span>consolidation</span> et l&apos;<span>imperméabilisation</span> de tous les supports minéraux poreux.</p>`,
    image: mineralisation_card,
    heroImage: mineralisation_hero,
    logoPlan: mineralisation_plan,
    dirDetailsImage: "mineralisation",
    details: {
      items: [
        {
          title: "Application par pulvérisation",
          text: `<p>Traitement à base de silice liquide (verre naturel sous forme de liquide). Cette solution écologique, à faire une fois dans la vie du matériau, va venir durcir et/ou créer une parois de verre dans le matériau poreux. Cette couche augmente la dureté du support et limitera l&apos;incrustation des salissures. Elle vous permettra donc de nettoyer plus facilement le revêtement et le rendra plus durable. </p>`,
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Entretien des massifs",
    textsCard: [
      "Désherbage, nettoyage, petite taille, coupe des fleurs fanées... dans un massif il y a toujours à faire tout au long de l&apos;année ! ",
    ],
    textDetail: /* html */ `<p>Un <span>désherbage régulier</span> ainsi qu&apos;une <span>taille raisonnée</span> et ponctuelle permet aux végétaux d&apos; ornement de s&apos; épanouir pleinement. </p>`,
    image: enretien_des_massif_card,
    heroImage: enretien_des_massif_hero,
    logoPlan: enretien_des_massif_plan,
    dirDetailsImage: "entretien-des-massifs",
    details: {
      items: [
        {
          title: "Désherbage",
          text: "<p>Maîtrise de la flore opportuniste par une action mécanique ou de façon raisonnée par l&apos; utilisation de produits biocontrôles.</p>",
        },
        {
          title: "Coupe des fleurs fanées",
          text: `<p>Une fois fanée, la fleur peut être coupée pour laisser la place aux autres qui vont arriver.</p>`,
        },
        {
          title: "Délimitation des espaces",
          text: `<p>Une découpe à la bêche permet de garder une délimitation nette entre vos espaces paysagers et votre surface engazonnée.  Attention tout de même si vous avez un robot de tonte, cette solution n&apos;est pas recommandée. </p>`,
        },
        {
          title: "Petite taille",
          text: `<p>Certains végétaux nécessitent plus d&apos;attentions et de soins que d&apos;autres. Une entretien spécifique, plus fin et régulier est alors à prévoir.</p>`,
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Entretien des surfaces engazonnées",
    textsCard: [
      "Scarification, traitement au produit biocontrôle, anti-mousse, apport d&apos;engrais, regarnissage... Etapes indispensables pour maintenir en forme votre pelouse. ",
    ],
    textDetail: /* html */ `<p>Actions indispensables pour garder une surface enherbée <span>dense</span>, <span>durable</span> et <span>homogène</span>.</p>`,
    image: entretien_des_pelouses_card,
    heroImage: entretien_des_pelouses_hero,
    logoPlan: entretien_des_pelouses_plan,
    dirDetailsImage: "entretien-des-surfaces-engazonnees",
    details: {
      items: [
        {
          title: "Anti-mousse & Scarification",
          text: "<p>Mise en place d&apos;un produit venant bruler les mousses et ainsi permettre leur extraction.  Le passage du scarificateur permet ensuite de les extraire. Pour finir elles sont ramassées puis évacuées.</p>",
        },
        {
          title: "Engrais",
          text: "<p>Nutriments essentiels au bon développement du végétal, un apport d&apos; amendement sous forme d&apos;engrais permettra à vos végétaux d&apos; être plus robustes et d&apos;avoir une meilleure croissance. </p>",
        },
        {
          title: "Regarnissage",
          text: "<p>La nature n&apos; aimant pas le vide, elle le comblera présent dans votre gazon par des espèces locales et opportunistes ! Afin de limiter au maximum l&apos; implantation de ces adventices, la mise en place de graines d&apos;engazonnement spécifiques n&apos;est pas une option. </p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
  {
    title: "Brossage",
    textsCard: [
      "Parce que le nettoyage haute pression rend les matériaux poreux, nous vous proposons une alternative : le brossage mécanique.",
    ],
    textDetail: /* html */ `<p><span>Action mécanique</span> rotative qui, à l&apos;aide d&apos;une tête spécifique composée de filaments mixtes, va venir <span>désencrasser</span> le support.</p>`,
    image: brossage_mecanique_card,
    heroImage: brossage_mecanique_hero,
    logoPlan: brossage_mecanique_plan,
    dirDetailsImage: "brossage",
    details: {
      items: [
        {
          title: "Brosse mécanique",
          text: "<p>L&apos;utilisation d&apos;un nettoyeur haute pression a tendance à abîmer le support en le rendant poreux et détériore les joints de vos dallages. L&apos;utilisation d&apos;une brosse mécanique évite ce désagrément et le résultat peut être spectaculaire ! </p>",
        },
      ],
      services: [
        {
          url: "/#",
          label: "Entretien",
        },
        {
          url: "/#",
          label: "Plantes",
        },
        {
          url: "/#",
          label: "Dallage",
        },
      ],
    },
  },
].map((item) => ({
  ...item,
  slug: slugify(item.title, { lower: true, strict: true, trim: true }),
  url: `/entretien/${slugify(item.title, {
    lower: true,
    strict: true,
    trim: true,
  })}`,
  details: {
    ...item.details,
    items: item.details.items.map((el, index) => ({
      ...el,
      image: `${mainDetailsImageDir}/${item.dirDetailsImage}/d${index + 1}.jpg`,
    })),
  },
}));
